import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Alert, Input } from 'reactstrap'
import Spinner from '../Spinner/Spinner.js'
import { ACTIVE_SCHEMAS_QUERY } from '../../graphql.js'
import { handleGraphQLErrors } from '../../utils'

export const ACTIVE_SCHEMAS = gql(ACTIVE_SCHEMAS_QUERY)

export default function SchemaSelect(props) {
  const { inputName, handleChange, invalid, valid, defaultValue } = props
  console.log('SchemaSelect rendered', props)

  const [items, setItems] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    async function fetchItems() {
      try {
        const { data, errors } = await window.apolloClient.query({ query: ACTIVE_SCHEMAS })
        if (data.getActiveSchemas) {
          const menuItems = []
          menuItems.push(<option key={0} value={null}></option>)
          for (let schema of data.getActiveSchemas) {
            menuItems.push(<option key={schema.name} value={schema.name}>{schema.name}</option>)
          }
          setItems(menuItems)
        }
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      }
    }
    if (!items) {
      fetchItems()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [items])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (items) {
    return (
      <Input
        defaultValue={defaultValue}
        type="select" name={inputName}
        onChange={handleChange}
        valid={valid}
        invalid={invalid}>
        {items}
      </Input>
    )
  } else {
    return <Spinner />
  }
}
